<template>
  <div>

    <div class="county-cards"
      v-for="indicator, index in indicators"
      :class="{'current': currentCard === index, 
        'next': currentCard + 1 === index, 
        'next2': currentCard + 2 === index, 
        'next3': currentCard + 3 === index, 
        'previous': currentCard - 1 === index}">

      <div class="padded">
        <div class="arrows">
          <button :disabled="index === 0" @click="currentCard--"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>
          <button :disabled="index >= indicators.length - 1" @click="currentCard++"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>
        </div>

        <h1 class="card-county" v-text="content.county"></h1>
        <h1 class="card-state" v-text="content.state"></h1>

        <hr />
      </div>

      <div class="padded overview" v-if="indicator.name === 'Overview'">
        <h5 v-text="indicator.fullname"></h5>

        <div v-for="indicator, index in allIndicators">
          <div class="opp-level" v-if="countyIndicators[index].oppLevel">
            <img :src="loadImg(indicator.image)" />
            {{ indicator.name }}
            <div class="stars">
              <i v-for="i in 4" :class="{ active: i <= countyIndicators[index].oppLevel }" class="fa fa-circle-o"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="padded" v-else>
        <img class="indicator-icon" :src="loadImg(indicator.image)" />
        <div class="indicator-data">
          <div class="indicator-longname" v-text="indicator.fullname"></div>
          <div class="county-metrics" v-html="countyIndicators[index].metrics"></div>
          <div class="opp-level" v-if="countyIndicators[index].oppLevel">
            <div class="stars">
              <i v-for="i in 4" :class="{ active: i <= countyIndicators[index].oppLevel }" class="fa fa-circle-o"></i>
            </div>
            <div class="opp-text" v-text="countyIndicators[index].oppText"></div>
          </div>
        </div>
      </div>
      
      <div class="indicator-image" v-if="indicator.thumb" :style="'background-image: url(' + loadImg(indicator.thumb) + ')'"></div>

    </div>

  </div>
</template>

<script>

export default {
  name: 'county-card',
  props: {
    'county': {
      type: [Number, String],
      required: true
    }
  },
  methods: {
    loadImg: function (path) {
      return require('../assets/' + path)
    }
  },
  computed: {
    countyIndicators() {
      var that = this;
      return _.flatten(_.map(this.$store.getters.getIndicators, function(indicator, index){ 
        return _.map(indicator.indicators, function(i, index2){
            return that.content.indicators[index][index2]
        });
      }));
    },
    allIndicators () {
      return _.flatten(_.map(this.$store.getters.getIndicators, function(i){ 
        return i.indicators
      }));
    },
    indicators () {
      return _.flatten(_.map(this.$store.getters.getIndicators, function(i, index){ 
          return _.filter(i.indicators, function(i2){ return i2.active })
        }));
    },
    content () {
      return this.$store.getters.getCounties[this.county]
    },
  },
  created (){

  },
  mounted (){

  },
  watch: {
    indicators: function() {
      if(this.currentCard >= this.indicators.length - 1) {
        this.currentCard = this.indicators.length - 1
      }
    }
  },
  data () {
    return {
      currentCard: 0,
    }
  }
}
</script>

<style lang="scss">
@import '../scss/global';

.county-cards {
  position: absolute;
  background: #fff;
  width: 300px;
  height: 336px;
  box-shadow: 0 0 7px transparentize(#000, 0.75);
  border-radius: $global-radius;
  padding: 1em 0;
  opacity: 0;
  visibility: hidden;
  top: 50px;
  right: -5px;
  color: #505050;
  transition: none;

  &.previous {
    opacity: 0;
    z-index: 9;
    right: 75px;
    top: 0px;
    // transform: rotate(-10deg);

    transition: all 0.35s ease-in-out;
    .indicator-image {
      opacity: 1;
    }
  }

  &.current {
    visibility: visible;
    opacity: 1;
    z-index: 5;
    top: 20px;
    right: 25px;
    transition: all 0.35s ease-in-out;

    .indicator-image {
      opacity: 1;
    }
  }

  &.next {
    visibility: visible;
    opacity: 1;
    z-index: 3;
    top: 25px;
    right: 20px;
  }
  &.next2 {
    visibility: visible;
    opacity: 0.66;
    z-index: 2;
    top: 30px;
    right: 15px;
  }

  &.next3 {
    visibility: visible;
    opacity: 0.33;
    z-index: 1;
    top: 35px;
    right: 10px;
  }

  .padded {
    padding-left: 15px;
    padding-right: 15px;
    position: relative;
  }

  hr {
    clear: both;
    border-color: #E8E8E8;
    margin: 0.75rem auto;
  }

  h1 {
    font-size: 1.25em;
    line-height: 1em;
    margin: 0;
    text-transform: uppercase;

    &.card-county {
    }

    &.card-state {
    }
  }

  button {
    &:disabled {
      i {
        color: #DEDEDE;
      }
    }

    i {
      color: #6D9D35;
    }
  }

  .arrows {
    float: right;

    button {
      border: none;
      background: none;
      font-size: 20px;
      outline: none;
      padding: 0 5px;
      cursor: pointer;
    }
  }

  .indicator-icon {
    // top: 0.75em;
    top: 0;
    position: absolute;
  }

  .opp-level {
    line-height: 1.6;

    .stars {
      float: left;
      margin-top: 0.15em;
    }

    .fa-circle-o {
      color: #43392d;
      opacity: 0.20;
      letter-spacing: 2px;
      font-size: 1.25em;

      &.active {
        opacity: 0.75;
        color: #43392d;

        &:before {
          content: '\f111' !important;
        }
      }
    }

    img {
      max-width: 1.25em;
      max-height: 1.25em;
      margin-right: 0.5em;
    }
  }

  .overview {
    h5 {
      font-size: 1em;
      color: white;
      background-color: $primary-color;
      padding: 0.25em 0.5em;
      text-transform: uppercase;
      margin-top: -0.75rem;
      margin-bottom: 1em;
    }

    .stars {
      float: right;
      margin-top: 0px;
    }

    .opp-level {
      .fa-star {
        font-size: 0.9em;
      }
    }
  }

  .indicator-data {
    margin-left: 3.5em;
    margin-bottom: 125px;

    .opp-level {  
      &:before {
        content: 'Opportunity Level';
        text-transform: uppercase;
        display: block;
        font-size: 0.75em;
        margin-top: 1em;
      }

      img {
        min-width: 2em;
        min-height: 1.5em;
        display: inline-block;
        margin-right: 0.5em;
        opacity: 0.5;

        &.active {
          opacity: 1;
        }
      }
    }

    .opp-text {
      float: right;
      margin-right: 0.25em;
    }
  }

  .indicator-image {
    width: 100%;
    height: 120px;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0.5em;
    left: 0;
    background-position: center center;
    background-size: cover;
    opacity: 0;
  }

  .indicator-longname {
    font-size: 1em;
    vertical-align: middle;
    line-height: 1;
  }

  .county-metrics {
    font-size: 42px;
    font-weight: 700;

    .fa {
      font-size: 18px;
    }
    .red {
      color: red;
    }
    .green {
      color: green;
    }
  }

  &.fade-enter-active, &.fade-leave-active {
    transition: all .5s
  }
  &.fade-enter, &.fade-leave-to {
    top: 50%;
    transform: scale(0.5);
  }

}

</style>



// WEBPACK FOOTER //
// CountyCards.vue?05218966